module.exports = __webpack_public_path__ + "media/images/launching_title-362df7992481ab5ad82ebd8f5cca3e38.png";